import { CustomTextField } from '../../../../../components/CustomTextField';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import { MenuItem } from '@mui/material';
import React, {useState} from 'react';
import {useTranslation} from "react-i18next";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CafeteriaFields = ({ item, statusList, disabled, emptyFields, handleChange, errorCode, errorName, isValid}) => {
    const {t} = useTranslation();

    return (<>
        <div className={`col-12`}>
            <CustomTextField
                id='txt_cf_name'
                name='name'
                value={item?.name}
                trans='name'
                type='text'
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                isValid={errorName}
                isValidText='the_value_already_exists'
                required={true}
                length={64}
            />
        </div>
        <div className={`col-12`}>
            <CustomTextField
                id='txt_cf_code'
                name='code'
                value={item?.code}
                trans='code'
                type={'text'}
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                isValid={errorCode}
                isValidText='the_value_already_exists'
                required={true}
                length={16}
            />
        </div>
        <div className={`col-12`}>
            <CustomSelectAndChildren
                id='slt_cf_status_id'
                name='statusId'
                trans='status'
                disabled={disabled}
                onChange={handleChange}
                value={item?.statusId || ''}
                emptyFields={emptyFields}
                required={true}
                showNoSelectionOption={false}
            >
                {statusList?.map((item) => (
                    <MenuItem key={item?.id} value={item?.id}>
                        {t(item.name)}
                    </MenuItem>
                ))}
            </CustomSelectAndChildren>
        </div>
        <div className={`col-12`}>
            <CustomTextField
                id='txt_cf_capacity'
                name='capacity'
                value={item?.capacity}
                trans='capacity'
                type={'number'}
                disabled={disabled}
                onChange={handleChange}
                emptyFields={emptyFields}
                required={true}
                length={3}
                isValid={isValid}
                isValidText={"this_value_must_be_greater_than_0"}
                helperText={"this_value_must_be_greater_than_0"}
            />
        </div>

        <div className={`col-12`}>
            <CustomTextField
                id='txt_cf_description'
                name='description'
                value={item?.description}
                trans='description'
                type='text'
                disabled={disabled}
                onChange={handleChange}
                multiline={true}
                length={512}
            />
        </div>
    </>)
}

export default CafeteriaFields;
